import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TaskParticipationDTO } from '../dtos/task-participation.dto';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ExportConfigDTO } from 'src/app/platform/dtos/export-config.dto';

@Injectable({
  providedIn: 'root',
})
export class TaskParticipationService {
  constructor(private readonly httpClient: HttpClient) {}

  getUserTaskParticipation(
    organizationId: string,
    studyId: string,
    username: string,
    filter?: string,
  ): Observable<TaskParticipationDTO[]> {
    let url = `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}/user/${username}/tasks-participations`;
    if (filter) {
      url += `?$filter=${filter}`;
    }
    return this.httpClient.get<TaskParticipationDTO[]>(url);
  }

  addTaskParticipation(
    organizationId: string,
    studyId: string,
    username: string,
    payload: TaskParticipationDTO,
  ): Observable<TaskParticipationDTO> {
    return this.httpClient.post<TaskParticipationDTO>(
      `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}/user/${username}/task-participation`,
      payload,
    );
  }

  updateTaskParticipation(
    organizationId: string,
    studyId: string,
    username: string,
    payload: TaskParticipationDTO,
  ): Observable<TaskParticipationDTO> {
    return this.httpClient.put<TaskParticipationDTO>(
      `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}/user/${username}/task-participation`,
      payload,
    );
  }

  generateUserPaymentReport(
    organizationId: string,
    studyId: string,
    username: string,
    filter: string,
    config: ExportConfigDTO,
  ): Observable<HttpResponse<any>> {
    let url = `${environment.dsmbHost}/dsmb/organization/${organizationId}/study/${studyId}/user/${username}/generate-payment-report`;
    if (filter) {
      url += `?$filter=${filter}`;
    }
    return this.httpClient.post(url, config, { responseType: 'blob', observe: 'response' });
  }

  generatePaymentReport(filter: string, config: ExportConfigDTO): Observable<HttpResponse<any>> {
    let url = `${environment.dsmbHost}/dsmb/payment-report`;
    if (filter) {
      url += `?$filter=${filter}`;
    }
    return this.httpClient.post(url, config, { responseType: 'blob', observe: 'response' });
  }
}
